import React from 'react';

export interface IFloatingIndicatorProps {
  id?: string;
  count: number;
  theme?: 'dark' | 'light';
}

const FloatingIndicator: React.FC<IFloatingIndicatorProps> = ({
  count,
  id,
  theme = 'light',
}) => {
  return count !== 0 ? (
    <span
      data-test="cartamount"
      id={id}
      className={`absolute -right-0 -top-1 flex h-4 w-4 items-center justify-center rounded-full pt-px text-center text-xxs font-black lg:-right-2 lg:text-xs ${
        theme === 'light'
          ? 'bg-primary-main text-other-white lg:bg-other-white lg:text-primary-main '
          : 'bg-other-white text-primary-main lg:bg-primary-main lg:text-other-white '
      }`}
    >
      {count}
    </span>
  ) : null;
};

export default FloatingIndicator;
